import { deserialize } from 'cerialize'

export class SberGeoUnitModel {
	@deserialize public id: number
	@deserialize public vsp_code: string
	@deserialize public longitude: unknown
	@deserialize public latitude: unknown
	@deserialize public name: string
	@deserialize public area_name: string
	@deserialize public region_name: string
	@deserialize public town_type: string
	@deserialize public town_name: string
	@deserialize public street_type: string
	@deserialize public street_name: string
	@deserialize public house_name: string
	@deserialize public corp_name: string
	@deserialize public operations: string[]
	@deserialize public sber_geo_unit_branch_address_string?: string
	@deserialize public code_nsi?: number
	@deserialize public sber_geo_unit_code_nsi?: number
	@deserialize public sber_geo_unit_address_string?: string
	@deserialize public sber_mq_region_id?: number

	public get string_name(): string | undefined {
		const { street_type, street_name, house_name, corp_name, name } = this
		return `${street_type ?? ''} ${street_name ?? ''}, д.${house_name ?? ''} ${
			corp_name ? `корп.${corp_name}` : ``
		}, ${name ?? ''}`
	}
}

export interface SberGeoUnitParams {
	vsp_code: string
	name: string
	house_name: string
	corp_name: string
	with_manager: boolean
	sber_mq_region_id: number
	region_name: string
	town_name: string
	street_name: string
}

export type SberGeoUnitParamsKeys = keyof SberGeoUnitParams
